export var SIZE_OPTIONS = [{
  value: 'A4',
  landscape: false
}, {
  value: 'A4_Landscape',
  landscape: true
}, {
  value: 'A3',
  landscape: false
}, {
  value: 'A3_Landscape',
  landscape: true
}];
export var FORMAT_OPTIONS = [{
  name: 'png',
  mime: 'image/png'
}, {
  name: 'pdf',
  mime: 'application/pdf'
}];
export var SCALE_OPTIONS = ['map', 'configured'];
export var PAGE_OPTIONS = ['pageScale', 'pageDate'];

// width, height
export var WINDOW_SIZE = [850, 1200];
export var PREVIEW_SCALED_WIDTH = 200;
export var COORDINATE_POSITIONS = ['center', 'corners'];
export var COORDINATE_PROJECTIONS = ['map', 'EPSG:4326'];
export var UNSUPPORTED_FOR_CONFIGURED_SCALE = ['wmts'];